export default "__VITE_ASSET__CmJuH6jl__"